import axios from 'axios';
import { wrapClient } from '../request';
import { AppApi } from './components/AppApi';
import { AppConfigApi } from './components/AppConfigApi';
import { EnvironmentApi } from './components/EnvironmentApi';
import { MarketApi } from './components/MarketApi';
import { ModuleApi } from './components/ModuleApi';
import { ModuleIntegrationApi } from './components/ModuleIntegrationApi';
import { PlatformApi } from './components/PlatformApi';
import { ProductApi } from './components/ProductApi';
import { UserApi } from './components/UserApi';
import { FrontEndApi } from './components/FrontEndApi';
import { ServiceApi } from './components/ServiceApi';
import { ServiceIntegrationApi } from './components/ServiceIntegrationApi';
import { TerraPaymentApi } from './components/TerraPaymentApi';

class Terra {
  TERRA_HOST = window.REACT_APP_TERRA_API_URL;
  TERRA_BASE_API_URL = 'api/v1';

  private terraClient = wrapClient(
    axios.create({
      baseURL: window.REACT_APP_TERRA_API_URL,
    })
  );

  frontEnd = new FrontEndApi(this.terraClient);

  user = new UserApi(this.terraClient);
  product = new ProductApi(this.terraClient);
  platform = new PlatformApi(this.terraClient);
  market = new MarketApi(this.terraClient);
  environment = new EnvironmentApi(this.terraClient);

  app = new AppApi(this.terraClient);
  appConfig = new AppConfigApi(this.terraClient);

  service = new ServiceApi(this.terraClient);
  serviceIntegration = new ServiceIntegrationApi(this.terraClient);

  module = new ModuleApi(this.terraClient);
  moduleIntegration = new ModuleIntegrationApi(this.terraClient);

  terraPayment = new TerraPaymentApi(this.terraClient);
}

export default new Terra();
